export default function getErrorMessage(exception) {
  if (exception.response && exception.response.data) {
    return exception.response.data.message;
  }

  return exception.message;
}
